import { render } from "./user-layout2.vue?vue&type=template&id=6c746aff&scoped=true&ts=true"
import script from "./user-layout2.vue?vue&type=script&lang=ts"
export * from "./user-layout2.vue?vue&type=script&lang=ts"

import "./user-layout2.vue?vue&type=style&index=0&id=6c746aff&lang=less&scoped=true"

import exportComponent from "/root/workspace/LiYuLoginSaaS_ql2g/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c746aff"]])

export default __exports__